<template>
  <div class="w_100per h_100per">
    <!-- 채널이 재생중일 경우 모달 띄우기 -->
    <ConfirmYesNoV2 v-if="isOpenConfirmYesNo" @click-no="isOpenConfirmYesNo = false" @click-yes="onClickYes">
      <template #confirmmodal-title>로고송 들어보기</template>
      <template #confirmmodal-desc>
        현재 재생중인 음악을 정지하고, <br />
        로고송을 재생할까요?
      </template>
    </ConfirmYesNoV2>
    <!-- 생성 도중 Yes/No 모달 -->
    <ConfirmYesNoV2
      v-if="isOpenConfirmYesNoCancel"
      @click-no="isOpenConfirmYesNoCancel = false"
      @click-yes="onClickYesCancelAiMusic"
    >
      <template #confirmmodal-title>로고송 만들기가 취소됩니다</template>
      <template #confirmmodal-desc> 취소하면 횟수가 차감됩니다. <br />정말로 취소하시겠습니까? </template>
    </ConfirmYesNoV2>
    <!-- AI뮤직 오디오1-->
    <audio
      id="aiMusicAudio1"
      :src="audioSrc1"
      hidden
      ref="audio1"
      @ended="onAudioEndedAudio1"
      @pause="onPauseAudio1"
    ></audio>
    <!-- AI뮤직 오디오2-->
    <audio
      id="aiMusicAudio2"
      :src="audioSrc2"
      hidden
      ref="audio2"
      @ended="onAudioEndedAudio2"
      @pause="onPauseAudio2"
    ></audio>
    <PageSlot>
      <template #pageslot-contents>
        <div class="max1440-container completeaimusic-cotainer" :class="aiMusicStatus === 1 ? '' : 'complete'">
          <!-- 준비중 : 1, 준비중 로딩 -->
          <div class="circle-loader-wrap" v-if="aiMusicStatus === 1 || !isEndVideo">
            <CommonLoader />
          </div>
          <!-- 준비완료: 2, 준비완료 최상단 텍스트 -->
          <h1 class="completeaimusic-title" v-html="statusTitle"></h1>
          <p class="select-song-text" v-if="aiMusicStatus === 2 && isEndVideo">마음에 드는 곡을 골라주세요.</p>
          <!-- 준비중 : 1, 안내 영상 -->
          <div class="infovideo-wrap" v-if="aiMusicStatus === 1 || !isEndVideo">
            <video ref="introduceVideo" class="infovideo-box" :src="videoSrc" autoplay muted @ended="onEnded"></video>
          </div>
          <!-- 준비완료: 2, 준비완료 노래선택 -->
          <ul class="aimusic-logosong-list" v-if="aiMusicStatus === 2 && isEndVideo">
            <li class="aimusic-logosong-item" v-for="(item, index) in aiMusicList" :key="item.itemNo">
              <a tabindex="0" class="logosong-checkwrap cursor" @click="selectIdx = index">
                <img
                  class="logosong-check"
                  :src="
                    index === selectIdx
                      ? '/media/images/icon/checked-lg-icon.png'
                      : '/media/images/icon/unchecked-lg-icon.png'
                  "
                  alt="unchecked-lg-icon.png"
                />
              </a>

              <a
                tabindex="0"
                class="logosong-infowrap cursor"
                @click="selectIdx = index"
                :class="selectIdx === index ? 'active' : ''"
              >
                <!-- Dim Img -->
                <div class="logosong-img-dim"></div>
                <!-- AI Music Img -->
                <img class="logosong-img" :src="item.imageUrl" alt="aimusic_dummy1.png" />
                <!-- Equalizer -->
                <div class="equalizer-wrap" v-if="item.isPlay">
                  <CommonEqualizer />
                </div>
                <!-- LogoSong PlayStatus -->
                <a class="logosong-playcontrol cursor" tabindex="0" @click.stop="controlAudio(item, index, $event)">
                  <img
                    v-if="item.isPlay"
                    class="logosong-pause-icon"
                    src="/media/images/icon/pause-white-md-icon.png"
                    alt="logosong-pause-icon "
                  />
                  <img
                    v-else
                    class="logosong-play-icon"
                    src="/media/images/icon/play-white-icon.png"
                    alt="logosong-pause-icon "
                  />

                  <!-- <font-awesome-icon v-else class="logosong-play-icon" :icon="['fas', 'play']" /> -->
                </a>
              </a>
            </li>
          </ul>
          <!-- 준비완료:2 , 완료 버튼 -->
          <div class="complete-btnwrap" v-if="aiMusicStatus === 2 && isEndVideo">
            <BasicButton :boxsize="'md'" :disabled="isBtnDisabled" @click-btn="onClickUpdateSelectGeneratedMusic">
              <template #btnname>
                완료
              </template>
            </BasicButton>
          </div>
        </div>
      </template>
    </PageSlot>
  </div>
</template>
<script>
import PageSlot from '@/slot/PageSlot.vue';
import CommonLoader from '@/components/common/CommonLoader.vue';
import CommonLoadingBars from '@/components/common/CommonLoadingBars.vue';
import BasicButton from '@/components/BasicButton/BasicButton.vue';
import ConfirmYesNoV2 from '@/components/common/ConfirmYesNoV2.vue';
import CommonEqualizer from '@/components/common/CommonEqualizer.vue';
import { checkGenerateMusicApi, updateSelectGeneratedMusicApi, getVideoUrlApi } from '@/service/api/mySoundApi';
export default {
  components: {
    PageSlot,
    CommonLoader,
    BasicButton,
    CommonLoadingBars,
    ConfirmYesNoV2,
    CommonEqualizer
  },
  beforeRouteLeave(to, from, next) {
    this.nextFn = next;
    this.$gatag.event('web_ai_music_generate_page_back'); // 로고송 생성 페이지 뒤로가기
    this.isOpenConfirmYesNoCancel = true;
    this.$gatag.event('web_ai_music_generate_done_back'); // 로고송 생성 뒤로가기 경고 팝업
    const { name } = to;
    if (name === 'BroadCast') {
      next();
      return;
    }
    return false;
  },
  data() {
    return {
      nextFn: () => {},
      aiMusicStatus: 1, // 1 : 준비중 , 2: 준비 완료
      isOpenConfirmYesNo: false, // 재생중인게 있을 경우 확인 모달
      isOpenConfirmYesNoCancel: false, // 생성 도중 Yes/No 모달
      selectAiMusic: -1,
      isEndVideo: false,
      isWatchVideo: sessionStorage.getItem('isWatchVideo') ? parseInt(sessionStorage.getItem('isWatchVideo')) : -1,
      interVal: -1,
      audioSrc1: null,
      audioSrc2: null,
      userId: this.$cookies.get('userId'),
      status: null,
      aiMusicList: [],
      selectIdx: -1,
      selectTempIdx: -1, // 스트리밍 재생중일 경우, 팝업 띄우기 전에 임시로 가지고 있는 Idx
      selectItem: null,
      btnDisabled: false,
      spaceId: this.$cookies.get('spaceId'),
      videoSrc: null
    };
  },
  created() {
    if (this.isWatchVideo > -1) {
      this.isEndVideo = true;
    }
    this.getVideoUrl();
    this.checkGenerateMusic();
    // 10초
    this.interVal = setInterval(() => {
      this.checkGenerateMusic();
    }, 10000);
  },
  mounted() {},
  methods: {
    onEnded() {
      this.isEndVideo = true;
      sessionStorage.setItem('isWatchVideo', 1);
      this.$refs.introduceVideo.play();
    },
    async getVideoUrl() {
      try {
        const { data } = await getVideoUrlApi(this.userId);
        const { resultCd, result } = data;
        if (resultCd === '0000') {
          const { videoUrl } = result;
          this.videoSrc = videoUrl;
          this.$refs.introduceVideo.play();
        } else {
          throw Error(resultCd);
        }
      } catch (error) {
        console.log('getVideoUrl error : ', error);
      }
    },
    handlePopState() {
      this.isOpenConfirmYesNoCancel = true;

      // 다시 현재 페이지로 push해서 히스토리 복원 (이동 차단)
      history.pushState(null, '', location.href);
    },
    onPauseAudio1() {
      this.aiMusicList[0].isPlay = false;
    },
    onPauseAudio2() {
      this.aiMusicList[1].isPlay = false;
    },
    onClickYes() {
      this.$store.dispatch('controlMusic');
      this.isOpenConfirmYesNo = false;
      this.controlAudio(this.selectItem, this.selectTempIdx);
    },
    onClickYesCancelAiMusic() {
      this.isOpenConfirmYesNoCancel = false;
      sessionStorage.removeItem('isWatchVideo');
      // 라우터 이동 처리
      this.nextFn();
    },
    onAudioEndedAudio1() {
      this.aiMusicList[0].isPlay = false;
    },
    onAudioEndedAudio2() {
      this.aiMusicList[1].isPlay = false;
    },
    async onClickUpdateSelectGeneratedMusic() {
      try {
        this.$gatag.event('web_ai_generate_item_select'); // 로고송 선택
        this.btnDisabled = true;
        const { itemNo } = this.aiMusicList[this.selectIdx];
        const { data } = await updateSelectGeneratedMusicApi(
          this.userId,
          this.spaceId,
          this.$route.params.genmusicid,
          itemNo
        );
        const { resultCd } = data;
        if (resultCd === '0000') {
          // 이후 로직 처리 필요
          this.$router.push({ name: 'BroadCast' });
        } else {
          throw Error(resultCd);
        }
      } catch (error) {
        console.log(error.response);
        if (error.response.status === 400) {
          const { data } = error.response;
          const { resultMsg } = data;
          alert(resultMsg);
        }
        console.log(error);
      } finally {
        this.btnDisabled = false;
      }
    },
    async controlAudio(aiMusicItem, index) {
      const { isPlay } = aiMusicItem;

      if (isPlay) {
        // 재생중일 경우
        if (index === 0) {
          this.$refs.audio1.pause();
        } else {
          this.$refs.audio2.pause();
        }

        aiMusicItem.isPlay = false;
      } else {
        // 중지일 경우
        if (this.getIsPlay) {
          this.selectTempIdx = index;
          this.selectItem = aiMusicItem;
          this.isOpenConfirmYesNo = true;
          return;
        }
        if (index === 0) {
          this.$refs.audio2.pause();
          this.aiMusicList[1].isPlay = false;
          this.$refs.audio1.currentTime = 0;
          this.$refs.audio1.play();
          this.aiMusicList[0].isPlay = true;
        } else {
          this.$refs.audio1.pause();
          this.aiMusicList[0].isPlay = false;
          this.$refs.audio2.currentTime = 0;
          this.$refs.audio2.play();
          this.aiMusicList[1].isPlay = true;
        }
      }
    },
    async checkGenerateMusic() {
      try {
        const { data } = await checkGenerateMusicApi(this.userId, this.$route.params.genmusicid, this.spaceId);
        const { resultCd, result } = data;
        if (resultCd === '0000') {
          const { list, status } = result;
          if (status === 'TEXT_SUCCESS' || status === 'FIRST_SUCCESS' || status === 'SUCCESS') {
            this.$gatag.event('web_ai_generate_done'); // 로고송 완료
            this.aiMusicList = list.map(item => {
              return {
                ...item,
                isPlay: false
              };
            });
            if (this.aiMusicList.length > 0) {
              this.audioSrc1 = this.aiMusicList[0].streamAudioUrl;
              this.audioSrc2 = this.aiMusicList[1].streamAudioUrl;
            }
            this.aiMusicStatus = 2;
            clearInterval(this.interVal);
            this.interVal = -1;
          }
        } else {
          throw Error('checkGenerateMusicApi : ' + resultCd);
        }
      } catch (error) {
        console.log('checkGenerateMusic error ' + error);
      }
    }
  },
  computed: {
    statusTitle() {
      if (this.aiMusicStatus === 1) {
        return `지금 로고송을 만들고 있어요.`;
      } else if (this.aiMusicStatus === 2 && this.isEndVideo) {
        return `“${this.aiMusicList[0].title}” 로고송이 <br/>완성 되었습니다!`;
      }
      return `지금 로고송을 만들고 있어요.`;
    },
    spaceName() {
      return this.$store.getters.getSpaceName;
    },
    getIsPlay() {
      return this.$store.getters.gettersIsPlay;
    },
    isBtnDisabled() {
      if (this.selectIdx !== -1) {
        return this.btnDisabled;
      }
      return true;
    }
  },
  beforeDestroy() {
    clearInterval(this.interVal);
  }
};
</script>
<style scoped src="@/assets/css/completeaimusic/completeaimusic.css"></style>
